import React, { Component } from "react";
import TopNav from "../containers/TopNav/TopNav";
import MobileNavbar from "../containers/MobileNavbar";
import Footer from "../containers/Footer";
import Conversations from "../containers/messaging/Conversations";
class Messages extends Component {
  render() {
    return (
      <div className="app-wrapper has-mobile-navbar">
        <TopNav />

        <Conversations />

        <MobileNavbar />
        <Footer />
      </div>
    );
  }
}

export default Messages;
